/* global google:false */
/* global PhotoSwipe:false */
/* global PhotoSwipeUI_Default:false */

function fixedFooter() {

    var instagramFeed = $("#sbi_images");
    var wrapperFooter = $("#wrapper-footer");
    var page = $("#page");
    if ( instagramFeed.length > 0 && window.innerWidth > 992 && window.innerHeight > 750) {
        instagramFeed.imagesLoaded(function () {
            wrapperFooter.addClass('fixed-bottom');
            page.css( "margin-bottom", wrapperFooter.height() );
        });
    }
    else {
        wrapperFooter.removeClass('fixed-bottom');
        page.css( "margin-bottom", "" );
    }
}

function resizeImages() {

    if (window.innerWidth < window.innerHeight) {
        $('.first-slideshow').addClass('fsh-fix').removeClass('fsw-fix');
    } else {
        $('.first-slideshow').addClass('fsw-fix').removeClass('fsh-fix');
    }

    $( ".listing-wrapper .type-room" ).each( function(e){
        var haWidth = $(this).width();
        var haHeight = $(this).height();

        if(haWidth < haHeight) {
            $(this).addClass('hah-fix').removeClass('haw-fix');
        } else {
            $(this).addClass('haw-fix').removeClass('hah-fix');
        }
    });

}

$(document).ready(function() {
    "use strict";

    var supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;

    fixedFooter();
    resizeImages();

    var $webhotelierForm = $("#webhotelier-form");
    if ($webhotelierForm.length > 0 ) {
        var elWebhotelierForm = $webhotelierForm;
        elWebhotelierForm.webhotelierForm(elWebhotelierForm.data('json'));
    }

    var highlightsStrecherItem = $("#highlights-stretcher-wrapper .card");
    if (highlightsStrecherItem.length > 0 && ! supportsTouch) {
        highlightsStrecherItem.each(function() {
            if ( ! $(this).hasClass('card-more')) {
                highlightsStrecherItem.on({
                    mouseenter: function() {
                        $(this).find(".card-img-overlay").addClass("d-flex").removeClass("d-none");
                        $(this).find(".card-img").attr('src', $(this).find(".card-img").attr('data-hover-image'));
                        $(this).addClass("active");
                    },
                    mouseleave: function() {
                        $(this).find(".card-img-overlay").addClass("d-none").removeClass("d-flex");
                        $(this).find(".card-img").attr('src', $(this).find(".card-img").attr('data-image'));
                        $(this).removeClass("active");
                    }
                });
            }
        });
    }

    /**
     * Posts Slider
     */
    var postsSlider = $('*[data-posts-slider]');
    if (postsSlider.length > 0) {
        postsSlider.each(function() {

            var $slickWrapper = $(this);
            var $slickElement = $(this).find('.posts-slider-inner');

            $slickElement.on('init reInit afterChange', function( event, slick, currentSlide ) {
                $slickWrapper.find('.counter-active').text((currentSlide ? currentSlide : 0) + 1);
                $slickWrapper.find('.counter-total').text(slick.slideCount);
            });

            $slickElement.slick({
                prevArrow: $slickWrapper.find('.arrow-left'),
                nextArrow: $slickWrapper.find('.arrow-right'),
                fade: true,
                mobileFirst: true,
            });

        });
    }

    /**
     * First Slideshow
     */
    var $firstSlideshow = $('*[data-first-slideshow]');
    if ($firstSlideshow.length > 0) {
        $firstSlideshow.flickity({
            contain: true,
            autoPlay: 4000,
            cellSelector: '.slideshow-cell',
            accessibility: true,
            prevNextButtons: false,
            pageDots: false,
            setGallerySize: false,
            imagesLoaded: true,
            lazyLoad: true,
            draggable: '>1',
            wrapAround: true,
            friction: 0.48
        });
    }


    /**
     * Footer Links Slideshow
     */
    var $dataFooterLinksSlideshow = $('*[data-footer-links-slideshow]');
    if ($dataFooterLinksSlideshow.length > 0) {
        $dataFooterLinksSlideshow.flickity({
            contain: true,
            autoPlay: 4000,
            cellSelector: '.slideshow-footer-cell',
            accessibility: true,
            prevNextButtons: true,
            pageDots: true,
            setGallerySize: false,
            imagesLoaded: true,
            lazyLoad: true,
            draggable: '>1',
            wrapAround: true,
            groupCells: true,
            autoplay: 2000,
            friction: 0.48
        });
    }

    /**
     * Newsletter Form
     */
    var $secondaryFields = $('#ms-sub-form #secondary_fields');
    if ($secondaryFields.parent().find('#email').length > 0) {
        $("#ms-sub-form #email").focusin(function() {
            $secondaryFields.fadeIn('slow').removeClass('d-none');
        });
    }

    /**
     * Accommodation Filtering
     */
    var filters = $('.filters');
    if (filters.length > 0) {
        var listingWrapper = $('.listing-wrapper');
        listingWrapper.imagesLoaded( function() {
            listingWrapper.isotope({
                itemSelector: 'article',
            });

        });
        filters.on('click', 'a', function() {
            var filterValue = $(this).attr('data-filter');
            listingWrapper.isotope({
                filter: filterValue,

            });
        });

    }

    /**
     * Page Inner Slider
     */
    var $tabSlideshow = $('*[data-tab-slideshow]');
    if ($tabSlideshow.length > 0) {
        $tabSlideshow.each(function() {
            var el = $(this);

            el.flickity({
                contain: true,
                cellSelector: '.slideshow-cell',
                accessibility: true,
                prevNextButtons: el.find('.slideshow-cell').length > 1,
                pageDots: el.find('.slideshow-cell').length > 1,
                // setGallerySize: false,
                imagesLoaded: true,
                lazyLoad: true,
                wrapAround: true
            });

        });
    }

    /**
     * Masonry Gallery
     */
    var $gallery = $('#masonry-gallery');
    if ($gallery.length > 0) {
        $gallery.imagesLoaded( function() {
            // init Isotope after all images have loaded
            $gallery.isotope({
                itemSelector: '.gallery-item',
                percentPosition: true,

                // layout mode options
                masonry: {
                    gutter: '.gallery-gutter-sizer',
                    columnWidth: '.gallery-item-sizer'
                }

            });
        });

        /**
         * Filter items on button click
         */
        $('#masonry-gallery-filters li').on('click', 'a', function() {
            $gallery.isotope({
                filter: $(this).attr('data-filter')
            });
        });


        /**
         * Lightbox
         */
        $gallery.photoswipeLightbox($gallery.data('photoswipe-options'));
    }

    /**
     * Google Map
     */
    var $map = $('.map');
    if ($map.length > 0) {
        var elMap = $map;

        elMap.googleMap(elMap.data('json'));
    }


    /**
     * Date & Time
     */
    var $dateTime = $('.date-data');
    if ($dateTime.length > 0) {
        var elTime = $dateTime;

        elTime.dateTime(elTime.data('json'));
    }

    /**
     * Contact Form
     */
    var contact_form = $('.wpcf7-form');
    if (contact_form.length > 0) {
        contact_form.find('input, textarea').on('focus', function() {
            var parent = $(this).parent().parent();
            parent.addClass('active');
            $(this).on('focusout', function() {
                if ($(this).val() === '') {
                    parent.removeClass('active');
                }
            });
        });
    }

    /**
     * Room Links
     */
    var listHomeRoomsLinks = $('#list-home-rooms a');
    if (listHomeRoomsLinks.length > 0) {
        var listHomeRoomsTabContent = $('.home-rooms-tab-content').parent().is(':visible');
        if ( ! listHomeRoomsTabContent) {
            listHomeRoomsLinks.each(function() {
                $(this).removeAttr('data-toggle');
            });
        }
    }

    if ( $("#fixed-message").length > 0 ) {
        var messageHeight = $("#fixed-message").outerHeight() + 16;
        $(".navbar.navbar-expand").css("padding-top",messageHeight);
    }

});

$(function() {
    "use strict";

    var body = $("body");
    // var header = $(".navbar.fixed-top");
    var navbarExternalContent = $("#navbarToggleExternalContent");
    var navbarTogglerText = $(".navbar-toggler .navbar-text");


    $(window).on('resize orientationchange', function() {

        fixedFooter();

    });

    $(window).on('scroll', function() {

        var scroll = $(window).scrollTop();
        if (scroll >= 150) {
            // header.addClass("scrolled");
            body.addClass("scrolled");
        } else {
            // header.removeClass("scrolled");
            body.removeClass("scrolled");
        }

    });

    $(navbarExternalContent).on('show.bs.collapse', function () {
        // header.addClass("menu-open");
        body.addClass("position-fixed menu-open");
        navbarTogglerText.text(navbarTogglerText.attr('data-label-close'));
    });

    $(navbarExternalContent).on('hide.bs.collapse', function () {
        // header.removeClass("menu-open");
        body.removeClass("position-fixed menu-open");
        navbarTogglerText.text(navbarTogglerText.attr('data-label-open'));
    });

    $('a[data-hover="tab"]').on('mouseenter', function () {
        var id = $(this).attr('data-target');
        $(id).siblings().removeClass('show active');
        $(this).tab('show');
    });

});

(function($) {
    "use strict";

    $.fn.webhotelierForm = function(options) {
        var el = $(this);

        var settings = $.extend({
            // 'split_dates': $(this).data('split_dates'),
            // 'icon_dates': $(this).data('icon_date'),
        }, options);

        var checkinDateSplit = el.find('#checkin-date-split');

        // var formIcons =
        function getField(id) {
            var el = $('#' + id + '-picker');
            return el.length ? el : null;
        }

        function fillSplitDates(id) {
            var el = getField(id);
            if (el !== null) {
                var date = el.datepicker("getDate");
                el.parent().find('.day').text(date.getDate());
                el.parent().find('.month').text(date.toLocaleString(document.documentElement.lang,{month: "short"}));
                el.parent().find('.year').text(date.getFullYear());
            }
        }

        function pickerSetup(id, date) {
            var el = getField(id);

            if (el !== null) {
                var checkin = (id === 'checkin');

                el.datepicker({
                    altField: el.get(0).form[id],
                    altFormat: 'yy-mm-dd',
                    dateFormat: 'd M yy',
                    onSelect: function () {
                        if (checkin && getField('checkout') !== null) {
                            var constraint = new Date(el.datepicker('getDate'));
                            constraint.setDate(constraint.getDate() + 1);
                            getField('checkout').datepicker("option", 'minDate', constraint);
                        }
                        if ( settings.split_dates ) {
                            fillSplitDates(id);
                        }
                    },
                    numberOfMonths: 2,
                    mandatory: true,
                    firstDay: 1,
                    minDate: checkin ? 0 : 1,
                    maxDate: '+2y',
                    showOn: settings.icon_date ? 'button' : 'focus',
                    buttonImage: settings.icon_date ? settings.icon_date : '',
                    buttonImageOnly: settings.icon_date ? 'true' : 'false',
                    buttonText: 'Select date'
            });
                el.datepicker("setDate", date);

                if ( checkinDateSplit.length > 0 ) {
                    fillSplitDates(id);
                }
            }
        }

        pickerSetup("checkin", "+0");
        pickerSetup("checkout", "+1");

        $('#checkin-date-split, #checkout-date-split').on('click', function() {
            $( this ).parent().find('input').datepicker( "show" );
        });

    };

    // Google Map Function
    $.fn.googleMap = function(options) {
        var el = $(this);

        var settings = $.extend({
            'lat': '37.979561',
            'lng': '23.728487',
            'zoom': 13,
            'styles': '',
            'places_categories': false,
            'locations': [{
                lat: -33.890542,
                lng: 151.274856,
                address: '',
                tooltip: false,
                marker_svg: false,
                marker_svg_file: false,
                image_src: '',
                image_alt: '',
                info_title: '',
                info_text: '',
                info_btn: '',
                info_btn_url: '',
                info_btn_target: '',
            }],
        }, options);

        var markers = [];
        var bounds = new google.maps.LatLngBounds();
        var directionsDisplayOptions = {
            suppressMarkers: true
        };
        var directionsService = new google.maps.DirectionsService;
        var directionsDisplay = new google.maps.DirectionsRenderer;
        directionsDisplay.setOptions( directionsDisplayOptions );

        // var offsetHeight = $('nav.navbar').position();
        var offsetHeight = $('nav.navbar').height() * 2;

        var map = new google.maps.Map(el[0], {
            zoom: settings.zoom,
            zoomControl: true,
            scaleControl: false,
            scrollwheel: false,
            styles: settings.styles ? settings.styles : '',
            streetViewControl: false,
            disableDoubleClickZoom: true,
            mapTypeControl: false,
            fullscreenControl: false
        });

        $.each(settings.locations, function (i, attr) {

            var locLatLng = new google.maps.LatLng(attr.lat, attr.lng);
            var infoButtonString = "";
            var infoImageUrl = "";
            var markerInfowindow = false;
            var icon = false;

            if (attr.info_btn_url) {
                infoButtonString = '<p><a href="' + attr.info_btn_url + '" target="' + attr.info_btn_target + '">' + attr.info_btn + '</a></p>';
            }

            if (attr.image_src) {
                infoImageUrl = '<div class="side-gmap"><img src="' + attr.image_src + '" alt="' + attr.image_alt + '" /></div>';
            }

            if (attr.marker_svg_file) {
                icon = {
                    url: attr.marker_svg_file,
                    fillColor: '#7b7480',
                    // anchor: new google.maps.Point(-200, -200),
                    // scaledSize: new google.maps.Size(96, 96),
                    // strokeWeight: 0,
                    scale: 0.5,
                    // rotation: 0
                };
            }

            if (attr.info_text || attr.info_title) {
                var contentString =
                    '<div class="map-infowindow">' +
                    infoImageUrl +
                    '<div class="main-gmap">' +
                    '<h3 class="text-dark">' + attr.info_title + '</h3>' +
                    '<div class="text-dark">' + attr.info_text +
                    infoButtonString +
                    '</div>' +
                    '</div>' +
                    '</div>';

                markerInfowindow = new google.maps.InfoWindow({
                    content: contentString
                });
            }

            var marker = new google.maps.Marker({
                position: locLatLng,
                map: map,
                icon: icon ? icon : '',
                draggable: false,
                zIndex: -20,
                infowindow: markerInfowindow ? markerInfowindow : false,
            });

            markers.push(marker);

            marker.addListener('click', function () {
                hideAllInfoWindows(map);
                if (this.infowindow) {
                    this.infowindow.open(map, this);
                }
                map.setCenter(this.getPosition());
                map.panTo(this.getPosition());

                if (offsetHeight) {
                    map.panBy(0, -offsetHeight);
                }
            });

            map.panTo(marker.getPosition());

            if (offsetHeight) {
                map.panBy(0, -offsetHeight);
            }

            bounds.extend(locLatLng);

            if (attr.routes) {
                if (Object.keys(attr.routes).length > 1) {

                    if ($('#collapse-location-routes.collapse').length > 0 && $(window).height() > 767) {
                        $('#collapse-location-routes.collapse').collapse();
                    }

                    $('#location-routes .list-group-item-action').on('click', function (e) {
                        e.preventDefault();
                        $('#location-place-categories').find('.list-group-item-action.active').removeClass('active');
                        var elId = $(this).attr('id');
                        $.each(attr.routes, function (k, routeAttr) {
                            if (elId === routeAttr.title.toLowerCase()) {
                                clearMarkers();
                                var routeLocLatLng = new google.maps.LatLng(routeAttr.lat, routeAttr.lng);
                                calculateAndDisplayRoute(directionsService, directionsDisplay, locLatLng, routeLocLatLng);
                            }
                        });
                    });
                }
            }
        });

        if (settings.places_categories) {

            var placeMarkers = [];

            $('#location-place-categories .list-group-item-action').on('click', function (e) {
                e.preventDefault();
                $('#location-routes').find('.list-group-item-action.active').removeClass('active');

                if ($(this).find('.place-category-icon')) {
                    var markerColor = $(this).find('.place-category-icon').css("background-color");
                }

                // Clear directions if any
                directionsDisplay.setMap(null);
                clearMarkers();

                var elId = $(this).attr('id');

                $.each(settings.places_categories, function (title, placesCategory) {
                    if (elId === placesCategory.title) {
                        $.each(placesCategory.places, function (title, place) {

                            var placeMarkerInfowindow = false;
                            var placeIcon = {
                                // anchor: new google.maps.Point(0, 0),
                                strokeColor: markerColor,
                                path: 'M75.85 68.35L42.5 110 9.15 68.35A41.83 41.83 0 0 1 0 42.21C0 18.94 19.06 0 42.5 0S85 18.93 85 42.2c0 9.87-3.42 18.95-9.15 26.14zM42.5 22.65c-10.55 0-19.13 8.52-19.13 19s8.58 19 19.13 19 19.13-8.52 19.13-19-8.58-19-19.13-19zm0 7.6',
                                fillColor: markerColor,
                                fillOpacity: 1,
                                // scaledSize: new google.maps.Size(1, 1),
                                scale: 0.5,
                                // strokeWeight: 0,
                                // rotation: 0
                            };

                            if (placesCategory.marker_svg_file) {
                                placeIcon = {
                                    url: placesCategory.marker_svg_file,
                                    // anchor: new google.maps.Point(0, 0),
                                    strokeColor: markerColor,
                                    fillColor: markerColor,
                                    fillOpacity: 1,
                                    // scaledSize: new google.maps.Size(8, 8),
                                    scale: 1,
                                    // strokeWeight: 0,
                                    // rotation: 0
                                };
                            }

                            if (place.title || place.description) {
                                var placeContentString = '<div class="">';

                                if (place.title) {
                                    placeContentString = placeContentString + '<h5 class="">' + place.title + '</h5>';
                                }
                                if (place.description) {
                                    placeContentString = placeContentString + '<p class="mb-0">' + place.description + '</p>';
                                }
                                placeContentString = placeContentString + '</div>';

                                placeMarkerInfowindow = new google.maps.InfoWindow({
                                    content: placeContentString
                                });
                            }

                            var placeLocLatLng = new google.maps.LatLng(place.lat, place.lng);

                            var placeMarker = new google.maps.Marker({
                                position: placeLocLatLng,
                                map: map,
                                draggable: false,
                                icon: placeIcon ? placeIcon : '',
                                zIndex: -20,
                                infowindow: placeMarkerInfowindow ? placeMarkerInfowindow : false,
                            });

                            placeMarkers.push(placeMarker);
                            bounds.extend(placeLocLatLng);
                            map.fitBounds(bounds);
                            map.setCenter(bounds.getCenter());
                            map.setZoom(map.getZoom()-1);
                            map.panTo(bounds.getCenter());
                            if (offsetHeight) {
                                map.panBy(0, -offsetHeight);
                            }
                            // if (Object.keys(settings.locations).length > 1) {
                            //     map.fitBounds(bounds);
                            // }
                            // else if (Object.keys(settings.locations).length === 1) {
                            //     map.setZoom(settings.zoom-1);
                            // }

                            placeMarker.addListener('click', function () {
                                hideAllPlacesInfoWindows(map, placeMarkers);
                                if (this.infowindow) {
                                    this.infowindow.open(map, this);
                                }
                                map.setCenter(this.getPosition());
                                map.panTo(this.getPosition());

                                if (offsetHeight) {
                                    map.panBy(0, -offsetHeight);
                                }
                            });
                        });
                    }
                });
            });
        }

        if (Object.keys(settings.locations).length > 1) {
            map.fitBounds(bounds);
        }
        else if (Object.keys(settings.locations).length === 1) {
            map.setZoom(settings.zoom);
        }

        function hideAllInfoWindows(map) {
            markers.forEach(function (marker) {
                if (marker.infowindow) {
                    marker.infowindow.close(map, marker);
                }
            });
        }

        function calculateAndDisplayRoute(directionsService, directionsDisplay, start, end) {
            directionsService.route({
                origin: start,
                destination: end,
                travelMode: 'DRIVING'
            }, function(response, status) {
                if (status === 'OK') {
                    directionsDisplay.setDirections(response);
                    directionsDisplay.setMap(map);
                    // if (offsetHeight) {
                    //     map.panBy(500, +offsetHeight);
                    // }
                    map.setCenter(this.locLatLng);
                } else {
                    window.alert('Directions request failed due to ' + status);
                }
            });
        }

        function hideAllPlacesInfoWindows(map, placeMarkers) {
            placeMarkers.forEach(function (placeMarker) {
                if (placeMarker.infowindow) {
                    placeMarker.infowindow.close(map, placeMarker);
                }
            });
        }

        // Removes the markers from the map, but keeps them in the array.
        function clearMarkers() {
            setMapOnAll(null);
        }

        // Sets the map on all markers in the array.
        function setMapOnAll(map) {
            for (var i = 0; i < placeMarkers.length; i++) {
                placeMarkers[i].setMap(map);
            }
        }
    };

    // Photoswipe Lightbox
    $.fn.photoswipeLightbox = function(options) {
        var el = $(this);

        var settings = $.extend({
            closeOnScroll: true,
            escKey: true,
            arrowKeys: true,
            loop: true,
            history: true,
            focus: true,
            modal: true,
            showHideOpacity: true,
            closeEl: true,
            captionEl: true,
            fullscreenEl: true,
            zoomEl: true,
            shareEl: true,
            counterEl: true,
            arrowEl: true,
            preloaderEl: true,
        }, options);

        el.each( function() {
            var $pic     = $(this),
                getItems = function() {
                    var items = [];
                    $pic.find('a').each(function() {

                        var $href   = $(this).data('src'),
                            $w   = $(this).data('width'),
                            $h  = $(this).data('height'),
                            $msrc  = $(this).find('img').attr('src'),
                            $title  = $(this).data('title'),
                            $pid  = $(this).data('slug');

                        var item = {
                            src : $href,
                            w   : $w,
                            h   : $h,
                            msrc   : $msrc,
                            title   : $title,
                            pid   : $pid
                        };

                        items.push(item);
                    });
                    return items;
                };

            var items = getItems();

            var $pswp = $('.pswp')[0];
            $pic.on('click', 'a', function(event) {
                event.preventDefault();

                var $index = $(this).data('index');
                var options = {
                    index: $index,
                    bgOpacity: 0.7,
                    spacing: 0.12,
                    allowPanToNext: true,
                    pinchToClose: true,
                    closeOnScroll: settings.closeOnScroll,
                    closeOnVerticalDrag: true,
                    escKey: settings.escKey,
                    arrowKeys: settings.arrowKeys,
                    history: settings.history,
                    mouseUsed: false,
                    loop: settings.loop,
                    focus: settings.focus,
                    modal: settings.modal,
                    showHideOpacity: settings.showHideOpacity,
                    showAnimationDuration: 333,
                    hideAnimationDuration: 333,
                    closeEl: settings.closeEl,
                    captionEl: settings.captionEl,
                    fullscreenEl: settings.fullscreenEl,
                    zoomEl:  settings.zoomEl,
                    shareEl:  settings.shareEl,
                    counterEl: settings.counterEl,
                    arrowEl: settings.arrowEl,
                    preloaderEl:  settings.preloaderEl,
                };

                // Initialize PhotoSwipe
                var lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
                lightBox.init();
            });
        });
    };

    // Date & Time
    $.fn.dateTime = function(options) {
        var el = $(this);

        var settings = $.extend({
            'day'           : '.date-day',
            'time'          : '.date-time',
            'dayNames'      : new Array("Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"),
            'monthNames'    : new Array("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December")
        }, options);

        var func = {
            // Plugin Initialize Function
            init: function() {
                var self = this;

                self.getDate();
                setInterval(self.getDate, 500);
            },
            // Plugin Create Time
            getDate: function() {
                var today = new Date();
                var dayName = settings.dayNames[today.getDay()];
                var day = today.getDate();
                var month = settings.monthNames[today.getMonth()];
                var year = today.getFullYear();
                var hours = today.getHours();
                var mins = today.getMinutes();

                hours = func.checkTime(hours);
                mins = func.checkTime(mins);

                $(settings.day).html(dayName + " " + day + " " + month + " " + year);
                $(settings.time).html(hours + ":" + mins);
            },
            // Plugin Check Time
            checkTime: function(i) {
                if (i < 10) {
                    i = "0"+i;
                }

                return i;
            }
        };

        func.init();
    };

})(jQuery);
